import { usePatientStore } from "../../../hooks";

export const PatientSurgeryProcedureInfoCard = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientStore();

  const { procedure, description } = patientSurgery.data;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="card border shadow">
      <div className="card-body">
        <div className="vstack gap-2">
          <p className="mb-0">
            <strong>Propósito:</strong> {procedure.title}
          </p>
          <p className="mb-0">
            <strong>Descripción:</strong> {description}
          </p>
        </div>
      </div>
    </div>
  );
};
